
import BSelect from 'Src/js/components/blain-form/BSelect.vue';
import BTextField from 'Src/js/components/blain-form/BTextField.vue';
import LookupRadio from './form/LookupRadio.vue';
import LookupRadioButton from './form/LookupRadioButton.vue';
import StepWrapper from './StepWrapper.vue';
import UiButton from 'JS/components/UiButton.vue';
import VehicleIcon from 'Src/js/components/automotive/VehicleIcon.vue';
import WithImmutableObjectValue from 'JS/mixins/WithImmutableObjectValue';
import { capitalize } from 'JS/utilities/string';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { CustomerVehicleIconType } from 'JS/types/Automotive';
import { DetailsStep as IDetailsStep } from '../types/steps';

@Component({
	name: 'DetailsStep',
	components: {
		BSelect,
		BTextField,
		StepWrapper,
		LookupRadio,
		LookupRadioButton,
		UiButton,
		VehicleIcon,
	}
})
class DetailsStep extends Mixins(WithImmutableObjectValue<IDetailsStep['data']>(() => ({
		nickname: null,
		color: null,
		icon: null,
		availableColors: null,
		availableIcons: null
	}))) {

	@Prop({ type: Boolean, default: true })
	hasPreviousStep: boolean;


	get canContinue() {
		return true;
	}

	get colors() {
		return this.availableColors
			.filter(color => color !== 'default')
			.map(color => ({
				name: capitalize(color),
				value: color,
			}));
	}

	get icons() {
		return this.availableIcons.map(type => ({
			type,
			name: CustomerVehicleIconType[type],
		}));
	}
}

export default DetailsStep;

